import { useState } from "react";
import { Phone, WhatsappLogo, X, ChatCircleDots } from "@phosphor-icons/react";

const PHONE_DISPLAY = "07384 361344";
const PHONE_TEL = "tel:+447384361344";
const WHATSAPP_HREF =
  "https://wa.me/447384361344?text=" +
  encodeURIComponent("Hi Honeystone, I'd like a quote for my garden/home.");

export default function ContactFab() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed right-4 bottom-20 sm:right-6 sm:bottom-24 z-50 flex flex-col items-end gap-3" data-testid="contact-fab">
      {open && (
        <div className="flex flex-col gap-3 hs-fade">
          <a
            href={WHATSAPP_HREF}
            target="_blank"
            rel="noreferrer"
            className="group flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-5 h-12 shadow-[0_10px_30px_rgba(0,0,0,0.18)] hover:bg-[#1FB857] transition-colors"
            data-testid="contact-fab-whatsapp"
          >
            <WhatsappLogo size={22} weight="fill" />
            <span className="text-sm font-semibold">WhatsApp</span>
          </a>
          <a
            href={PHONE_TEL}
            className="group flex items-center gap-3 rounded-full bg-[#4F6F52] text-white pl-4 pr-5 h-12 shadow-[0_10px_30px_rgba(0,0,0,0.18)] hover:bg-[#3C5A3F] transition-colors"
            data-testid="contact-fab-call"
          >
            <Phone size={20} weight="fill" />
            <span className="text-sm font-semibold">Call {PHONE_DISPLAY}</span>
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Close contact options" : "Open contact options"}
        className={`h-14 w-14 rounded-full text-white shadow-[0_12px_30px_rgba(0,0,0,0.2)] flex items-center justify-center transition-colors ${open ? "bg-[#2C3E35] hover:bg-black" : "bg-[#4F6F52] hover:bg-[#3C5A3F]"}`}
        data-testid="contact-fab-toggle"
      >
        {open ? <X size={22} weight="bold" /> : <ChatCircleDots size={24} weight="fill" />}
      </button>
    </div>
  );
}

export { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_HREF };
